<template>
  <div style="overflow: hidden; height: 100vh" v-show="showLock">
    <popup-bg :show-lock="showLock">
      <div slot="custom-html">
        <div class="chat-title">
          <h2>{{ title }}</h2>
        </div>
        <div class="chat-wrap">
          <el-form
            :model="form"
            :rules="rules"
            ref="form"
            label-width="24%">
            <el-row>
              <el-col :span="24">
                <el-form-item
                  label="时间："
                  prop="tk_time">
                  <el-date-picker
                    v-model="form.tk_time"
                    type="datetime"
                    :editable="false"
                    placeholder="选择日期时间"/>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  label="备注："
                  prop="tk_memo">
                  <el-input
                    type="textarea"
                    :rows="3"
                    resize="none"
                    placeholder="请输入内容"
                    v-model="form.tk_memo"
                    class="menu"/>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  v-if="title === '计划任务'"
                  label="类型："
                  prop="tk_type">
                  <el-select
                    v-model="form.tk_type"
                    placeholder="请选择"
                    :disabled="setDisabled">
                    <el-option
                      v-for="item in options"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"/>
                  </el-select>
                </el-form-item>
                <div :class="`user-card ${student_error}`" v-if="form.tk_type && form.tk_type < 3">
                  <div class="card-content" v-if="form.crm_id && student.all_name">
                    <div class="first-line" @click="openStudentSearch">
                      <span class="hasname">{{ student.all_name ? student.all_name : '暂无名称' }}</span>
                      <span class="chat-right el-input__icon el-icon-arrow-up"></span>
                    </div>
                    <span class="phone-text" v-if="student.crm_tel">{{ student.crm_tel }}</span>
                    <span class="qq-text" v-if="student.crm_qq">{{ student.crm_qq }}</span>
                    <span class="wx-text" v-if="student.crm_weixin">{{ student.crm_weixin }}</span>
                  </div>
                  <div class="card-content" v-if="form.crm_id && !student.all_name">
                    <div class="first-line">
                      <span>正在获取学生数据...</span>
                      <span class="chat-right el-input__icon el-icon-arrow-up"></span>
                    </div>
                  </div>
                  <div class="card-content" v-if="!form.crm_id">
                    <div class="first-line" @click="openStudentSearch">
                      <span>请选择学生</span>
                      <span class="chat-right el-input__icon el-icon-arrow-up"></span>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="btn-area">
                  <el-button type="primary" @click="onSubmit" state-key="fib.jiemo.net/h5/common/plantask-保存" :state-status="true">保存</el-button>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div slot="close-button">
        <slot name="close-button"></slot>
      </div>
    </popup-bg>
    <div class="student-search-bg" v-show="studentLock" @touchstart.stop="closeStudentSearch">
      <div class="student-search-wrap">
        <div class="search-area">
          <el-input @change="searchInput" type="text" placeholder="模糊搜索"></el-input>
        </div>
        <div class="list-area">
          <div v-show="studentList.length > 0" class="list-content" v-for="item in studentList" :key="item.crm_id" @click="setStudentData(item)">
            <h3>{{ item.data.as_name }}</h3>
            <div class="info-area">
              <span class="phone-text" v-show="item.data.as_phone">{{ item.data.as_phone }}</span>
              <span class="qq-text" v-show="item.data.as_qq">{{ item.data.as_qq }}</span>
              <span class="wx-text" v-show="item.data.as_weixin">{{ item.data.as_weixin }}</span>
            </div>
            <div class="line"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import popupBg from './popupBg';

let task = {
  tk_time: '',
  tk_type: 1,
  tk_name: '',
  tk_memo: '',
  tk_create: '',
  crm_id: 0
};

export default {
  data () {
    return {
      studentLock: false,
      searchTimer: null,
      submitLock: false,
      studentList: [],
      form: {
        tk_time: ''
      },
      student_error: '',
      student: {},
      rules: {
        tk_time: [
          {
            type: 'date', required: true, message: '请选择时间', trigger: 'change'
          }
        ],
        tk_type: [
          {
            required: true, message: '请选择任务类型', trigger: 'change', type: 'number'
          }
        ],
        tk_name: [
          { required: true, message: '请输入学生姓名', trigger: 'change' }
        ],
        tk_memo: [
          { required: true, message: '请输入计划任务说明', trigger: 'blur' }
        ]
      }
    };
  },
  props: {
    showLock: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '计划任务'
    },
    taskForm: {
      type: Object,
      default() {
        return {};
      }
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    isReturnVisit: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    setDisabled() {
      return !!this.form.tk_id;
    }
  },
  mounted() {
  },
  methods: {
    // 打开学生查找
    openStudentSearch: function () {
      if (!this.form.id && this.title !== '预约回访') {
        this.studentLock = true;
      }
    },
    // 关闭学生查找
    closeStudentSearch: function(e) {
      e.stopPropagation();
      if (e.target.className === 'student-search-bg') {
        this.studentLock = false;
      }
    },
    // 查找输入
    searchInput: function(val) {
      if (val !== '') {
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => {
          this.$http
            ._post({
              url: '/index/plantask/searchName',
              data: {
                tk_name: val
              }
            })
            .then(({ data }) => {
              this.studentList = data;
            });
        }, 300);
      }
    },
    setStudentData(student) {
      let data = {};
      this.form.crm_id = student.crm_id;
      data.crm_id = student.crm_id;
      data.custom_name = String(student.data.as_name) === 'null' ? '' : student.data.as_name;
      data.crm_qq = student.data.as_qq;
      data.crm_tel = student.data.as_phone;
      data.crm_weixin = student.data.as_weixin;
      data.custom_nickname = String(student.data.custom_nickname) === 'null' ? '' : student.data.custom_nickname;
      data.all_name = `${data.custom_name ? data.custom_name : '暂无姓名'} | ${data.custom_nickname_tell ? data.custom_nickname_tell : '暂无昵称'}`;
      this.student = data;
      this.studentLock = false;
      this.student_error = '';
      this.initTkName();
    },
    getStudentInfo() {
      if (this.form.crm_id) {
        this.student = {};
        this.$http
          ._post({
            url: '/index/plantask/getStudentById',
            data: {
              id: this.form.crm_id
            }
          })
          .then(({ data }) => {
            this.student = data;
            this.student.all_name = `${this.student.custom_name ? this.student.custom_name : '暂无姓名'} | ${this.student.custom_nickname_tell ? this.student.custom_nickname_tell : '暂无昵称'}`;
            this.initTkName();
            console.log(this.form);
          })
          .catch(({ data }) => {
            if (data.result < 0) {
              this.$emit('update:showLock', false);
            }
          });
      }
    },
    initTkName() {
      let tkname = this.student.custom_name ? `姓名: 【${this.student.custom_name}】 ` : '';
      let tkqq = this.student.crm_qq ? `QQ: 【${this.student.crm_qq}】 ` : '';
      let tktel = this.student.crm_tel ? `电话:【${this.student.crm_tel}】 ` : '';
      let tkweixin = this.student.crm_weixin ? `微信: 【${this.student.crm_weixin}】 ` : '';
      this.form.tk_name = tkname + tkqq + tktel + tkweixin;
    },
    onSubmit() {
      if (this.submitLock) {
        this.$message({
          type: 'error',
          message: '正在提交请稍候'
        });
        return {};
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.crm_id || this.form.tk_type === 3 || this.form.tk_type === 4 || this.form.tk_type === 10) {
            this.submitLock = true;
            this.$http._post({
              url: '/index/Plantask/add',
              data: this.form,
            }).then((res) => {
              this.$emit('update:showLock', false);
              if (res.result === 0) {
                this.$message({
                  type: 'success',
                  message: res.msg
                });
                this.submitLock = false;
              }
            });
          } else {
            this.student_error = 'is-error';
            this.$message({
              type: 'error',
              message: '请选择学生'
            });
          }
        }
      });
    }
  },
  components: {
    'popup-bg': popupBg
  },
  watch: {
    taskForm() {
      this.form = Object.assign({}, task, this.$props.taskForm);
      this.form.tk_time = this.form.tk_time_int ? this.form.tk_time_int * 1000 : '';
      this.form.tk_type = this.form.tk_type_key ? this.form.tk_type_key : this.form.tk_type;
      this.form.id = this.form.tk_id ? this.form.tk_id : 0;
      this.getStudentInfo();
    },
    showLock() {
      if (!this.showLock) {
        this.student = {};
      }
    }
  }
};
</script>
<style>
  .chat-wrap .el-form .el-form-item .el-form-item__label{
    float: left;
  }
  .chat-wrap .el-form .el-form-item .el-date-editor, .chat-wrap .el-form .el-form-item .el-form-item__content .el-select{
    width: 100%;
  }
  .student-search-wrap .search-area .el-input .el-input__inner{
    background: #F8F8F8 url("../../../assets/wap/icon-search.png") no-repeat 2vw center;
    background-size: 4.26vw auto;
    border-radius: 1vw;
    padding-left: 10vw;
  }
</style>
<style scoped>
  .chat-title{
    text-align: center;
    padding: 7vw 0;
  }
  .chat-title h2{
    font-size: 4.8vw;
  }
  .chat-wrap{
    padding: 0 5vw;
  }
  .chat-wrap .el-form{
    margin-top: 0;
  }
  .chat-wrap .el-form .el-form-item{
    margin-right: 0;
    margin-bottom: 3.2vw;
  }
  .chat-wrap .user-card{
    background: #F1F5FC;
    border-radius: 1.6vw;
    padding: 0 3vw;
  }
  .chat-wrap .user-card .first-line{
    line-height: 11.2vw;
    position: relative;
    cursor: pointer;
  }
  .chat-wrap .user-card .first-line span:first-of-type{
    font-size: 3.73vw;
    color: #8F99BF;
  }
  .chat-wrap .user-card .first-line span.hasname{
    font-size: 4.5vw;
    font-weight: bold;
  }
  .chat-wrap .user-card .first-line .chat-right{
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%) rotate(180deg);
    color: #8F99BF;
    font-size: 4vw;
  }
  .chat-wrap .user-card .card-content > span{
    display: inline-block;
    line-height: 7.6vw;
    font-size: 3.73vw;
    color: #8F99BF;
    width: 50%;
    box-sizing: border-box;
    word-break: break-all;
    vertical-align: top;
    padding: 1.5vw 0 1.5vw 5.6vw;
  }
  .chat-wrap .user-card .card-content > span.phone-text{
    display: block;
    width: 100%;
    border-bottom: 0.5px dashed rgba(143, 153, 191, 0.5);
    background: url("../../../assets/wap/icon-backlog-1.png") no-repeat left 3vw;
    background-size: auto 4.2vw;
  }
  .chat-wrap .user-card .card-content > span.qq-text{
    background: url("../../../assets/wap/icon-backlog-3.png") no-repeat left 3vw;
    background-size: auto 4.2vw;
  }
  .chat-wrap .user-card .card-content > span.wx-text{
    background: url("../../../assets/wap/icon-backlog-2.png") no-repeat left 3vw;
    background-size: auto 4.2vw;
  }
  .chat-wrap .user-card.is-error {
    border: 1px solid;
    border-color: #f56c6c;
  }
  .chat-wrap .btn-area{
    text-align: center;
    padding: 4vw 0 7vw;
    clear: both;
  }
  .chat-wrap .btn-area .el-button{
    width: 56.5vw;
    height: 10.6vw;
    border-radius: 5.3vw;
    border: none;
  }
  .student-search-bg{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.7);
    z-index: 31;
  }
  .student-search-wrap{
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 55vh;
    background: #fff;
  }
  .student-search-wrap .search-area{
    padding: 4vw;
  }
  .student-search-wrap .list-area{
    height: 84%;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .student-search-wrap .list-area .list-content{
    position: relative;
    padding: 3vw 5vw;
  }
  .student-search-wrap .list-area .list-content h3{
    font-size: 4.53vw;
    line-height: 5vw;
    font-weight: normal;
    padding-bottom: 1vw;
  }
  .student-search-wrap .list-area .list-content .info-area{
    display: flex;
    justify-content: flex-start;
  }
  .student-search-wrap .list-area .list-content .info-area span{
    display: inline-block;
    color: #aeaeae;
    font-size: 3.73vw;
    padding-left: 5vw;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 2vw;
  }
  .student-search-wrap .list-area .list-content .info-area span.phone-text{
    background: url("../../../assets/wap/icon-dropdown-phone.png") no-repeat left center;
    background-size: auto 3.2vw;
    width: 36%;
  }
  .student-search-wrap .list-area .list-content .info-area span.qq-text{
    background: url("../../../assets/wap/icon-dropdown-qq.png") no-repeat left center;
    background-size: auto 3.2vw;
    width: 36%;
  }
  .student-search-wrap .list-area .list-content .info-area span.wx-text{
    background: url("../../../assets/wap/icon-dropdown-wx.png") no-repeat left center;
    background-size: auto 3.2vw;
    width: 28%;
  }
  .student-search-wrap .list-area .list-content .line{
    position: absolute;
    bottom: 0;
    left: 5vw;
    width: 90vw;
    height: 0;
    border-bottom: 1px solid #ececec;
  }
</style>
